import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../config/axiosInstance";
import { API_ENDPOINTS } from "../config/apiConfig";
import { setCartItems, clearCart } from "../redux/cartSlice"; // Redux actions
import "./OrderPage.css"; // Importing custom CSS
import nocover from "./../assets/images/nocover.jpg";

const OrderPage = () => {
    const dispatch = useDispatch();
    const userId = useSelector((state) => state.auth.userId); // Get userId from Redux
    const navigate = useNavigate();
    const { cartItems } = useSelector((state) => state.cart);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Fetch cart items from the backend
    useEffect(() => {
        if (!userId) return;
        const fetchCartItems = async () => {
            try {
                // const response = await axiosInstance.get(`${API_ENDPOINTS.PRODUCT_DETAILS}/${id}`);

                const response = await axiosInstance.get(`${API_ENDPOINTS.GET_CART}/${userId}`);
                dispatch(setCartItems(response.data.data)); // Updating Redux state
            } catch (err) {
                console.error("Error fetching cart items:", err);
                setError("Failed to load cart items.");
            } finally {
                setLoading(false);
            }
        };

        fetchCartItems();
    }, [dispatch, userId]);

    // Calculate total price
    const totalPrice = cartItems.reduce((acc, item) => acc + item.productPrice * item.quantity, 0);

    const handleCheckout = async () => {
        try {
            const orderPayload = { cartItems, totalPrice };
            const response = await axiosInstance.post(API_ENDPOINTS.PLACE_ORDER, orderPayload);
            console.log("Order placed successfully:", response.data);

            dispatch(clearCart()); // Clear cart after successful order
            alert("🚀 Order placed successfully!");
            navigate("/order-confirmation"); // Redirect to confirmation page
        } catch (err) {
            console.error("Error placing order:", err);
            alert("❌ Order failed. Please try again.");
        }
    };

    if (loading) return <div className="loading">Loading your cart...</div>;
    if (error) return <div className="error">{error}</div>;

    return (
        <div className="order-container">
            <h2 className="order-title">🛒 Your Order</h2>

            {cartItems.length === 0 ? (
                <div className="empty-cart">
                    <h5>Your cart is empty! 🛍</h5>
                    <button className="btn btn-primary" onClick={() => navigate("/")}>
                        Continue Shopping
                    </button>
                </div>
            ) : (
                <>
                    <div className="order-list">
                        {cartItems.map((item, index) => (
                            <div className="order-card" key={index}>
                                <img src={item.imageUrl || nocover} alt="Product" className="order-img" />
                                <div className="order-details">
                                    <h5 className="text-truncate">{item.productName}</h5>
                                    <p>Price: ₹{item.productPrice}</p>
                                    <p>Quantity: {item.quantity}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="order-summary">
                        <h4>Order Summary</h4>
                        <p><strong>Total Items:</strong> {cartItems.length}</p>
                        <p><strong>Total Price:</strong> ₹{totalPrice.toFixed(2)}</p>
                        <button className="btn btn-success" onClick={handleCheckout}>
                            Proceed to Checkout
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default OrderPage;
